export default function(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/treemap/slice.js
// module id = ./node_modules/d3-hierarchy/src/treemap/slice.js
// module chunks = 53